import "core-js/stable";
import Vue from "vue/dist/vue.esm";
import * as tables from "./10-atoms/30-table/table";
import "./10-atoms/40-select/select";
import "./20-molecules/30-blockquote/blockquote";
import * as slider from "./20-molecules/80-slider/slider";
import * as toggle from "./20-molecules/90-toggle/toggle";
import "./20-molecules/95-pillar-section/pillar-section";
import "./30-blocks/41-blog-feed-grid/blog-feed-grid";
import "./30-blocks/40-case-study-grid/case-study-grid";
import "./30-blocks/70-video-block/video-block";
import * as homeSectionShort from "./30-blocks/20-home-section-short/home-section-short";
import "./40-organisms/20-header/header";

Vue.config.productionTip = false;

(context => {
  tables.responsiveTable(context);
  slider.init(context);
  toggle.init(context);
  homeSectionShort.init(context);
})(document);
